import { CheckDataIfExit } from "src/helper/publicFunction";
import { setLoading } from "src/store/customizer/CustomizerSlice";
import { PostFunction } from "src/utils/axios_connection";
import UrlApi from "src/utils/Url";

export const GetSlideshow =
  ({ callback }) =>
  async (dispatch, getState) => {
    try {
      const response = await PostFunction({
        data: {},
        Route: UrlApi.slideshow.get, // Use from UrlApi
        showalert: false,
        state: getState,
        dispatch,
      });
      callback(response);
    } catch (err) {
      callback(false);
    }
  };

export const ManageSlideshow =
  ({ callback, values, editMode }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const bodyFormData = new FormData();
      
      if (editMode && values?.id) {
        bodyFormData.append("id", values.id);
      }
      
      if (values.title) bodyFormData.append("title", values.title.trim());
      if (values.description) bodyFormData.append("description", values.description.trim());
      if (values.button_text) bodyFormData.append("button_text", values.button_text.trim());
      if (values.button_url) bodyFormData.append("button_url", values.button_url.trim());
      if (values.display_order !== undefined) bodyFormData.append("display_order", values.display_order);
      if (values.is_active !== undefined) bodyFormData.append("is_active", Boolean(values.is_active));
      
      // Handle image upload - support arrays and FileList
      if (values.image) {
        if (Array.isArray(values.image) || values.image instanceof FileList) {
          // Multiple files
          const files = Array.isArray(values.image) ? values.image : Array.from(values.image);
          files.forEach((file, index) => {
            if (file instanceof File) {
              bodyFormData.append(`images[${index}]`, file);
            }
          });
        } else if (values.image instanceof File) {
          // Single file - new upload
          bodyFormData.append("image", values.image);
        } else if (typeof values.image === "string" && values.image.trim() !== "") {
          // Existing image URL - preserve it when editing
          bodyFormData.append("image_url", values.image);
        }
      } else if (editMode && values.image_url) {
        // When editing and no new image selected, preserve existing image
        bodyFormData.append("image_url", values.image_url);
      }

      // Use ternary to select correct URL
      const route = editMode ? UrlApi.slideshow.edit : UrlApi.slideshow.add;
      
      const response = await PostFunction({
        data: bodyFormData,
        Route: route,
        showalert: true,
        state: getState,
        isMultipart: true,
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const EditSlideshow =
  ({ callback, id, nameFailed, dataFailed }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const formData = new FormData();
      formData.append("id", id);
      // Convert boolean fields to proper boolean values
      if (nameFailed === "is_active") {
        formData.append(nameFailed, Boolean(dataFailed));
      } else {
        formData.append(nameFailed, dataFailed);
      }
      
      const response = await PostFunction({
        data: formData,
        Route: UrlApi.slideshow.edit, // Use from UrlApi
        showalert: true,
        state: getState,
        isMultipart: nameFailed === "image",
        dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };

export const DeleteSlideshow =
  ({ callback, id }) =>
  async (dispatch, getState) => {
    try {
      dispatch(setLoading(true));
      const response = await PostFunction({
        data: { ids: id },
        Route: UrlApi.slideshow.delete, // Use from UrlApi
        showalert: true,
        state: getState,
        isMultipart: false,
        dispatch: dispatch,
      });
      
      dispatch(setLoading(false));
      callback(response);
    } catch (err) {
      dispatch(setLoading(false));
      callback(false);
    }
  };